import type { ReviewIssue } from '../../types/reviewIssue';

/**
 * セル・項目に表示する「確認すべき理由」を組み立てる（#3262）。
 *
 * バリデーションエラー（#2815）・計算エラー（#3172）・要注意（#3262）は
 * ユーザーから見れば同じ「この項目を確認する理由」なので、1 行にまとめて出す。
 * 別々に出すと同じ内容が縦に並んだり、色が競合して優先度が分かりにくくなる。
 *
 * 重複は除く。バリデーションエラーと要注意の validation 由来は同じ内容になるため
 * （どちらも「必須項目です」など）、そのまま並べると 2 回出てしまう。
 *
 * @param validationError 既存のバリデーションエラー文言（未発生なら undefined）
 * @param calculationError 計算エラー文言（未発生なら undefined）
 * @param reviewIssues その項目の要注意
 * @returns 表示する理由の配列（発生順・重複なし）
 */
export const buildCellReviewReasons = (
  validationError: string | undefined,
  calculationError: string | undefined,
  reviewIssues: ReviewIssue[],
): string[] => {
  const reasons: string[] = [];
  const seen = new Set<string>();

  const push = (reason: string | undefined): void => {
    if (!reason || seen.has(reason)) return;
    seen.add(reason);
    reasons.push(reason);
  };

  // 入力の不備を先に出す。対処が明確なものから読ませる
  push(validationError);
  push(calculationError);
  for (const issue of reviewIssues) push(issue.message);

  return reasons;
};
